import { GET_LIST_COUPON } from "./type";

export const initialState = {
  listCoupon: [],
};

export function newCouponManagementReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LIST_COUPON:
      return {
        ...state,
        listCoupon: action.payload.data
      };
    default:
      return state;
  }
}
